import React, { Component } from "react";
import "./connect-tint-box.sass";
export class ConnectTintBox extends Component {
  render() {
    return /* @__PURE__ */ React.createElement("div", { onClick: this.props.onClick, className: "contest-builder-page__connect-tint-box" }, /* @__PURE__ */ React.createElement("span", null, this.props.text));
  }
}
